
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sinch-campaigns",
      function () {
        return require("private-next-pages/destinations/sinch-campaigns.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sinch-campaigns"])
      });
    }
  